import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },

  fonts: {
    // English
    heading:
      '"DIN Next LT Arabic", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
    body:
      '"DIN Next LT Arabic", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',

    // Arabic
    arabic:
      '"Tajawal", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
  },

  colors: {
    brand: {
      main: "#6b4ba0",
      secondary: "#000000",
    },
  },

  styles: {
    global: {
      body: {
        bg: "white",
        color: "gray.800",
      },
    },
  },
});

export default theme;
